import { InvoiceEditorVariant } from '../../../../../../../enums/invoiceEditorVariant'

export const variantsWithDepositSettlement: InvoiceEditorVariant[] = [
  InvoiceEditorVariant.FinalInvoiceNewFromQuote,
  InvoiceEditorVariant.FinalInvoiceDraftEdit,
]
